export default __webpack_public_path__ + "static/media/ransomewareRealcase-mobile-en.2f66c432.png";